// import ModalForm from "./Form";
import GroupFindListForm from "./GroupFindListForm";
import { ACADEMIC_FIND_GROUP, DATATABLE_EXPORT } from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const Schema = {
	components: { GroupFindListForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint: ACADEMIC_FIND_GROUP,
			tableId: "group-find-list-table",
			formId: "group-find-list-form",
			rowData: {},
			tableColumns: [
				{
					title: "Class Name",
					type: "custom-html",
					key: "courses",
					modifier: (value) => {
						return value?.course_name ?? "-";
					}
				},
				{
					title: "Course Type",
					type: "custom-html",
					key: "course_type",
					modifier: (value) => {
						return value?.course_type_name ?? "-";
					}
				},
				{
					title: "Group Class",
					type: "custom-html",
					key: "course_group",
					modifier: (value) => {
						return value?.course_group_name ?? "-";
					}
				},
				{
					title: "Centre",
					type: "custom-html",
					key: "center",
					modifier: (value) => {
						return value?.name ?? "-";
					}
				},
				{
					title: "Main Teacher",
					type: "custom-html",
					key: "main_teacher",
					modifier: (value) => {
						return value?.full_name ?? "-";
					}
				},
				{
					title: "Trainer Teacher",
					type: "custom-html",
					key: "trainer_teacher",
					modifier: (value) => {
						return value?.full_name ?? "-";
					}
				},
				{
					title: "Student Care #1",
					type: "custom-html",
					key: "student_care1",
					modifier: (value) => {
						return value?.full_name ?? "-";
					}
				},
				{
					title: "Student Care #2",
					type: "custom-html",
					key: "student_care2",
					modifier: (value) => {
						return value?.full_name ?? "-";
					}
				},
				{
					title: "CO Teacher",
					type: "custom-html",
					key: "co_teacher",
					modifier: (value) => {
						return value?.full_name ?? "-";
					}
				},
				{
					title: "SC Supervisor",
					type: "custom-html",
					key: "sc_supervisor",
					modifier: (value) => {
						return value?.full_name ?? "-";
					}
				},
				{
					title: "Start Week",
					type: "text",
					key: "start_week",
				},
				{
					title: "End Week",
					type: "text",
					key: "end_week",
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "GroupFindListTable",
				url: ACADEMIC_FIND_GROUP,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: "Edit Group",
						icon: "edit",
						type: "page",
						url: "/transaction/academic-find-group/edit",
						target: "", // _blank to open newtab
						uniqueKey: (rowData) => rowData.id,
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				filters: [
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
	},
};
